module.exports = __webpack_public_path__ + "static/img/12.4af8a1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/sp/12.png
// module id = HZGY
// module chunks = 0